/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TopConsumptionUsage {
    getFixupPrototypeFunction() { return TopConsumptionUsage.fixupPrototype; }

    static newInstance(model: Partial<TopConsumptionUsage>): TopConsumptionUsage {
        let obj = Object.assign(new TopConsumptionUsage(), model);
        TopConsumptionUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TopConsumptionUsage>): TopConsumptionUsage {
        if (!model) return null;
        return TopConsumptionUsage.newInstance(<TopConsumptionUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TopConsumptionUsage) {
        if (!obj) return;

        models.TopConsumptionUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TopConsumptionUsage): boolean {
        Object.setPrototypeOf(obj, TopConsumptionUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * Category of the top consumption usage
     */
    category: string;

    /**
     * Component associated with the top consumption usage
     */
    component: string;

    /**
     * Resource associated with the top consumption usage
     */
    resource: string;

    /**
     * Count of the top consumption usage
     */
    count: number;

}
